// Links de salida del marketplace hacia agora.red (vidriera del negocio, páginas de Ágora), con UTM para atribuir la visita al marketplace:
// utm_source=market.agora.red · utm_medium=referral · utm_campaign=<tipo de página> · utm_content=<lugar>.
// Los canonical y el JSON-LD NO pasan por acá: esos van a la URL limpia de agora.red.

// Sin `www.`: www.agora.red contesta 301 a agora.red y cada clic a reservar sumaría un salto.
const STOREFRONT_ORIGIN = 'https://agora.red';

/**
 * @param {string} path «/usuario», «/usuario/servicios/slug», «/funcionalidades»…
 * @param {{ campaign?: string, content?: string }} utm `campaign` = tipo de página que deriva
 *   («vendor_profile», «service_detail», «home»…); `content` = qué link («booking_cta», «service_card»).
 */
export function storefrontUrl(path, { campaign, content } = {}) {
  const url = new URL(path.startsWith('/') ? path : `/${path}`, STOREFRONT_ORIGIN);
  url.searchParams.set('utm_source', 'market.agora.red');
  url.searchParams.set('utm_medium', 'referral');
  if (campaign) url.searchParams.set('utm_campaign', campaign);
  if (content) url.searchParams.set('utm_content', content);
  return url.toString();
}

/** Vidriera del negocio o, con `serviceSlug`, la página de reserva de ese servicio. */
export function vendorStorefrontUrl(username, { serviceSlug, ...utm } = {}) {
  const base = `/${encodeURIComponent(username)}`;
  return storefrontUrl(serviceSlug ? `${base}/servicios/${encodeURIComponent(serviceSlug)}` : base, utm);
}
